import React from 'react';
import { find } from 'lodash';
import { useParams } from 'react-router-dom';
import { TranslateHTML, Translate } from 'core/translate';
import ModalImage from '../../components/modal/ModalImage';
import LegalDisclosure from '../../components/legalDisclosure/LegalDisclosure';

const PackageDetailsItem = ({ pckg }) => {
  const { description, disclaimer, longCfd, largeImageUrl } = pckg;

  return (
    <div className="package-details__container">
      <div className="package-details__description__container">
        <div
          dangerouslySetInnerHTML={{ __html: description }}
          className="package-details__description__header"
        />
        {longCfd && (
          <div
            dangerouslySetInnerHTML={{ __html: longCfd }}
            className="package-details__description"
          />
        )}
        {disclaimer && (
          <div
            dangerouslySetInnerHTML={{ __html: disclaimer }}
            className="package-details__disclaimer"
          />
        )}
      </div>
      <ModalImage
        url={largeImageUrl ? largeImageUrl : null}
        alt={description}
        showImageDisclosure
      />
    </div>
  );
};

const PackageDetails = ({ packages }) => {
  const { id } = useParams();
  const selectedPackage =
    (packages && packages[id]) || find(packages, { code: id });

  const { description, longCfd, disclaimer } = selectedPackage;

  return (
    <>
      <LegalDisclosure
        className="legal-disclosure--option-details"
        showAsStatic
      />
      <div className="package-details-container">
        <div className="package-details__heading">
          <Translate value="package.details.heading" />
        </div>
        <div className="package-details__content">
          {selectedPackage.packages.map((pckg) => {
            return <PackageDetailsItem key={pckg.code} pckg={pckg} />;
          })}
          <div className="package-details__container">
            <div className="package-details__description__container">
              <div className="package-details__description__header">
                <TranslateHTML
                  value="package.details.all.features"
                  packageName={description}
                />
              </div>
              {longCfd && (
                <div
                  dangerouslySetInnerHTML={{ __html: longCfd }}
                  className="package-details__description"
                />
              )}
              {disclaimer && (
                <div
                  dangerouslySetInnerHTML={{ __html: disclaimer }}
                  className="package-details__disclaimer"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PackageDetails;
